module.exports = __webpack_public_path__ + "img/waziria-logo.f253a55a.png";